export default "__VITE_ASSET__CaBmhA0e__"